import { Component, OnInit } from '@angular/core';
import { urlEndPoint } from 'src/app/common';
import { Message } from 'src/app/models/message';
import { Tier1 } from 'src/app/models/obs/tier1';
import { Tier1Service } from 'src/app/services/obs/tier1.service';

@Component({
  selector: 'app-opp',
  templateUrl: './opp.component.html',
  styleUrl: './opp.component.scss'
})
export class OppComponent implements OnInit {

  idEvenType: string = '3'; /* id para cargar info al slider*/
  t1: Tier1 = null;
  URL: string = urlEndPoint;
  msg: Message;

  constructor(
    private tier1Service: Tier1Service
  ) { }

  ngOnInit() {
    this.getTier1();
  }

  getTier1() {
    this.tier1Service.getOne(4).subscribe({
      next: res => {
        this.t1 = res['data'];
      },
      error: err => { this.msg = err; }
    });
  }
}

